import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const grey: string = ui.neutral[400];

export const dropdownItemCss = {
  display: "flex",
  justifyContent: "flex-start",
  whiteSpace: "nowrap",
};

export const iconCss = {
  display: "inline",
  height: "20px",
  marginRight: "0.5em",
  verticalAlign: "text-bottom",
  path: {
    stroke: grey,
  },
};
